module.exports = __webpack_public_path__ + "img/ML.69b5a29b.svg";